module.exports = __webpack_public_path__ + "img/partner-bg.598413ae.png";